import { render, staticRenderFns } from "./cloudPhoneSetup.vue?vue&type=template&id=01c431d8&scoped=true"
import script from "./cloudPhoneSetup.vue?vue&type=script&lang=js"
export * from "./cloudPhoneSetup.vue?vue&type=script&lang=js"
import style0 from "./cloudPhoneSetup.vue?vue&type=style&index=0&id=01c431d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c431d8",
  null
  
)

export default component.exports